module.exports = __webpack_public_path__ + "static/media/me.085ab41e.jpg";